import React, { ReactNode } from 'react';
import { BrandBadge } from '@hz-design-system/web-ui';

import Classes from './ListingOpvalSticker.module.scss';

interface ListingOpvalStickerProps {
  children: ReactNode;
  isGalleryView?: boolean;
}

const ListingOpvalSticker: React.FC<ListingOpvalStickerProps> = ({ children, isGalleryView = false }) => {
  const modifier = isGalleryView ? 'gallery' : 'list-item';

  return (
    <div className={`${Classes[`hz-Listing-Opvalsticker-wrapper--${modifier}`]}`} data-testid="listing-opval-sticker">
      <BrandBadge className={Classes['hz-Listing-Opvalsticker']}>{children}</BrandBadge>
    </div>
  );
};

export default ListingOpvalSticker;
